import axios from "axios";
import { Link } from "react-router-dom";
import { DownOutlined, ReloadOutlined } from "@ant-design/icons";
import "moment/locale/ko";
import locale from "antd/es/date-picker/locale/ko_KR";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import {
    PageHeader,
    Button,
    Form,
    DatePicker,
    Space,
    AutoComplete,
    Input,
    Select,
    Switch,
    Alert,
} from "antd";
import { Fragment, useEffect, useState } from "react";

import {
    Modal,
    Collapse,
    Image,
    Badge,
    List,
    Spin,
    Typography,
    Divider,
    Descriptions,
} from "antd";

const { Panel } = Collapse;

const { Paragraph, Title, Text } = Typography;
const { Option } = Select;

// const tailLayout = { wrapperCol: { offset: 8, span: 16 } };
const tailLayout = { wrapperCol: { offset: 0, span: 16 } };

// 코드 예시
const fetch = (callback) => {
    const timestamp = +new Date();

    // XML 파일을 받아오기 위한 요청
    axios
        .get("/ticketOpen.xml?rnd=" + timestamp, { responseType: "text" })
        .then((resp) => {
            // DOMParser를 사용해 XML 문서를 파싱
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(resp.data, "application/xml");

            // <TicketOpenInfo> 태그 추출
            const ticketOpenInfo =
                xmlDoc.getElementsByTagName("TicketOpenNames")[0];
            if (!ticketOpenInfo) {
                // <TicketOpenInfo> 태그가 없을 경우를 대비
                callback();
                return;
            }

            // <TicketOpenInfo> 안의 텍스트를 라인 단위로 분리
            const lines = ticketOpenInfo.textContent
                .split(/\r?\n/) // 개행 문자 기준으로 분리
                .map((line) => line.trim())
                .filter((line) => line !== "");

            // 필요한 형태(value, text)로 맵핑
            const d = lines.map((item) => ({
                value: item,
                text: item,
            }));

            // 알파벳 순으로 정렬
            d.sort((a, b) => a.value.localeCompare(b.value));

            // 테스트용 데이터 추가
            d.push({ value: "## 테스트", text: "## 테스트" });

            // 첫 번째 callback은 캐시를 새로고침하기 위함이라 가정
            callback();
            // 두 번째 callback으로 실제 데이터 전달
            callback(d);
        })
        .catch((err) => {
            console.error(err);
            // 에러 발생 시에도 callback은 한 번 호출해주어야 할 수 있음
            callback();
        });
};

// const fetch = (callback) => {
//     const timestamp = +new Date();
//     // console.log("/opens.json?rnd=" + timestamp);
//     axios.get("/opens.json?rnd=" + timestamp).then((resp) => {
//         // console.log(resp);
//
//         const d = resp.data.map((item) => ({
//             value: item.TicketOpenName,
//             text: item.TicketOpenName,
//         }));
//         // console.log(d);
//         d.sort((a, b) => {
//             // console.log(a);
//             return a.value.localeCompare(b.value);
//         });
//         d.push({ value: "## 테스트", text: "## 테스트" });
//
//         // console.log(d);
//
//         callback(); // for cache refresh
//
//         callback(d);
//     });
//
//     // const data = TicketOpens.map((item) => ({
//     //     value: item.TicketOpenName,
//     //     text: item.TicketOpenName,
//     // }));
//     // callback(data);
// };

// const TicketOpens = [];

const options = [
    { value: "10시 00분" },
    { value: "10시 30분" },
    { value: "11시 00분" },
    { value: "11시 30분" },
    { value: "12시 00분" },
    { value: "12시 30분" },
    { value: "13시 00분" },
    { value: "13시 30분" },
    { value: "14시 00분" },
    { value: "14시 30분" },
    { value: "15시 00분" },
    { value: "15시 30분" },
    { value: "16시 00분" },
    { value: "16시 30분" },
    { value: "17시 00분" },
    { value: "17시 30분" },
    { value: "18시 00분" },
    { value: "18시 30분" },
    { value: "19시 00분" },
    { value: "19시 30분" },
    { value: "20시 00분" },
    { value: "20시 30분" },
    { value: "21시 00분" },
    { value: "21시 30분" },
    { value: "22시 00분" },
    { value: "23시 00분" },
];

<DatePicker locale={locale} />;

/**
 * Order function by key.
 * @default "asc"
 * data => field to order (Object, List, Array).
 * key => the data to be order by this key.
 */
function orderListByKey(data, key, order) {
    const compareValues =
        (key, order = "asc") =>
        (elemA, elemB) => {
            if (!elemA.hasOwnProperty(key) || !elemB.hasOwnProperty(key))
                return 0;
            const comparison = elemA[key].localeCompare(elemB[key]);
            return order === "desc" ? comparison * -1 : comparison;
        };
    return data.sort(compareValues(key, order));
}

// 티켓오픈일정 줄 끝의 " - 숫자"는 의뢰인수라 화면에 보이지 않게 지운다.
// 예: "10.20 14:00 - 뮤지컬 쉐도우 인천 - 4" → "10.20 14:00 - 뮤지컬 쉐도우 인천"
const hideClientCount = (text) => text.replace(/[ \t]+-[ \t]*\d+[ \t]*$/gm, "");

// 좌석 목록 버튼 글자. button이 없거나 빈 값이면 "보기"다.
const seatCaption = (item) => item.button || "보기";

// 좌석 목록은 버튼 글자를 이 순서로 먼저 정렬하고, 없는 글자는 맨 뒤로 보낸다.
const seatCaptionOrder = ["보기", "...", "없음", "실패"];
const seatCaptionRank = (item) => {
    const rank = seatCaptionOrder.indexOf(seatCaption(item));
    return rank === -1 ? seatCaptionOrder.length : rank;
};

// "없음"과 "실패"는 같은 하단 묶음이며, 회색으로 그리고 클릭을 막는다.
const seatBottomCaptions = ["없음", "실패"];
const isSeatBottom = (item) => seatBottomCaptions.includes(seatCaption(item));

// 좌석 목록을 첫 "없음"/"실패" 앞에서 나눈다. 나뉜 목록마다 위에 구분선을 그린다.
// "없음"/"실패"가 없거나 목록이 그것들로 시작하면 나누지 않는다. 빈 목록은 기존대로 빈 그룹 하나([[]])다.
const seatGroups = (links) => {
    const bottomIndex = links.findIndex(isSeatBottom);
    return bottomIndex > 0
        ? [links.slice(0, bottomIndex), links.slice(bottomIndex)]
        : [links];
};

// 좌석 목록 항목. 버튼 글자가 "보기"가 아니면 모양은 그대로 두고 클릭만 막는다.
// href가 null이면 antd Button은 href 속성 없는 <a>로 그려진다.
const renderSeatItem = (item) => {
    const linked = seatCaption(item) === "보기";
    const href = linked ? item.link : null;
    const noClickStyle = linked ? undefined : { pointerEvents: "none" };
    // "없음"과 "실패"는 공연 이름과 버튼 글자를 회색(antd 보조 글자색)으로 그린다.
    const itemStyle = isSeatBottom(item)
        ? { ...noClickStyle, color: "rgba(0, 0, 0, 0.45)" }
        : noClickStyle;
    return (
        <List.Item
            style={{
                justifyContent: "flex-end", // 오른쪽 정렬
                border: "none", // 라인 제거
                padding: "0 0", // 각 항목의 패딩 조정
            }}
        >
            <Title
                level={5}
                style={{
                    lineHeight: "1.8",
                }}
            >
                <Space>
                    <a href={href} style={itemStyle}>
                        {item.name}
                    </a>
                    <Button htmlType="button" href={href} style={itemStyle}>
                        {seatCaption(item)}
                    </Button>
                </Space>
            </Title>
        </List.Item>
    );
};

const RequestNew = ({ userShortId }) => {
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalText, setModalText] = useState("로딩중...");
    const [modalMoreEl, setModalMoreEl] = useState(null);
    const [modalHasMore, setModalHasMore] = useState(false);

    // 티켓오픈일정 모달: 아래에 내용이 더 있는지 확인
    useEffect(() => {
        const body = modalMoreEl && modalMoreEl.parentElement;
        if (!body || !isModalOpen) {
            return;
        }
        const update = () => {
            setModalHasMore(
                body.scrollHeight - body.clientHeight - body.scrollTop > 1
            );
        };
        update();
        body.addEventListener("scroll", update);
        window.addEventListener("resize", update);
        return () => {
            body.removeEventListener("scroll", update);
            window.removeEventListener("resize", update);
        };
    }, [modalMoreEl, isModalOpen, modalText]);

    // 데이터 fetch 함수
    const [links, setLinks] = useState([]);
    const [loading, setLoading] = useState(true);
    const fetchData = async () => {
        setLoading(true);
        try {
            const timestamp = +new Date();
            const response = await axios.get("/links.json?rnd=" + timestamp);

            let links = response.data.filter((item) => "name" in item); // infos 만
            links = links.filter((item) => item.name !== "공연명");

            // // 받은 데이터를 수정
            // let modifiedData = links.map((item) => ({
            //     title: item.infos[0],
            //     href: item.infos[1],
            // }));

            // 정렬: 버튼 글자 순서가 먼저, 같으면 공연명 순
            links.sort((a, b) => {
                const rankDiff = seatCaptionRank(a) - seatCaptionRank(b);
                if (rankDiff !== 0) {
                    return rankDiff;
                }
                return a.name.localeCompare(b.name);
            });

            setLinks(links);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const showModal = () => {
        setModalText("\r\n로딩중...");
        const timestamp = +new Date();

        axios
            .get("/ticketOpen.xml?rnd=" + timestamp, {
                responseType: "text",
            })
            .then((resp) => {
                const parser = new DOMParser();
                const xmlDoc = parser.parseFromString(
                    resp.data,
                    "application/xml"
                );

                // <TicketOpenInfo> 태그를 찾아서 CDATA 내용을 추출
                const ticketOpenInfoElement =
                    xmlDoc.getElementsByTagName("TicketOpenInfo")[0];
                if (ticketOpenInfoElement) {
                    const cdataContent = hideClientCount(
                        ticketOpenInfoElement.textContent
                    ).trim();
                    setModalText("\r\n" + cdataContent);
                } else {
                    setModalText("\r\n<TicketOpenInfo> 태그가 없습니다.");
                }
            })
            .catch((err) => {
                console.error(err);
                setModalText("\r\n데이터 로딩 에러가 발생했습니다.");
            });

        setIsModalOpen(true);
    };

    // const showModal = () => {
    //     setModalText("\r\n로딩중...");
    //     const timestamp = +new Date();
    //
    //     axios
    //         .get("/ticketOpen.xml?rnd=" + timestamp, { responseType: "text" })
    //         .then((resp) => {
    //             // DOMParser를 사용해 XML 문서를 파싱
    //             const parser = new DOMParser();
    //             const xmlDoc = parser.parseFromString(
    //                 resp.data,
    //                 "application/xml"
    //             );
    //
    //             // <TicketOpenInfo> 태그 추출
    //             const ticketOpenInfo =
    //                 xmlDoc.getElementsByTagName("TicketOpenInfo")[0];
    //
    //             if (!ticketOpenInfo) {
    //                 // 태그가 없으면 안내 메시지
    //                 setModalText("\r\n<TicketOpenInfo> 태그가 없습니다.");
    //             } else {
    //                 // 텍스트를 라인 단위로 분리
    //                 const lines = ticketOpenInfo.textContent
    //                     .split(/\r?\n/);
    //
    //                 // 모달에 표시
    //                 setModalText("\r\n" + lines.join("\r\n"));
    //             }
    //         })
    //         .catch((err) => {
    //             console.error(err);
    //             setModalText("\r\n에러가 발생했습니다.");
    //         });
    //
    //     setIsModalOpen(true);
    // };

    // const showModal = () => {
    //     setModalText("\r\n로딩중...");
    //     const timestamp = +new Date();
    //     // console.log("/opens.json?rnd=" + timestamp);
    //     axios.get("/sch.txt?rnd=" + timestamp).then((resp) => {
    //         // console.log(resp);
    //         setModalText("\r\n" + resp.data);
    //     });
    //
    //     setIsModalOpen(true);
    // };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const [openData, setOpenData] = useState([]);

    const [state, setState] = useState({ loading: false });

    const [form] = Form.useForm();

    const onReset = () => {
        form.resetFields();
    };

    function handleChange(value) {
        console.log(`selected ${value.label}`);
    }

    function onChange(date, dateString) {
        console.log(date, dateString);
        form.resetFields(["playTime"]);
    }

    function sleep(ms) {
        return new Promise((r) => setTimeout(r, ms));
    }

    const onFinish = (values) => {
        console.log("Success:", values);
        setState({ loading: true });

        {
            /* curl -X POST -k http://localhost:8090/requests -d '{"newRequest": {"userHp": "01093402046", "ticketOpenId": 1, "ticketOpenName": "더데빌 2차", "playDate": "2021.12.12", "playTime": "17시 00분", "siteLoginId": "jhch78", "siteLoginPwd": "gkswlsdn78#", "clientCnt": 4}}' */
        }

        // 01093402046, 테스트
        var hashedUserId = "";
        if (values.userHp.replaceAll("-", "").trim() === "01093402046") {
            hashedUserId = "a99f4e5d-3a4b-46ac-a244-41f6a68cd669";
        }

        axios
            .post(`/requests`, {
                newRequest: {
                    userHp: values.userHp.replaceAll("-", "").trim(),
                    userTicketOpenName: values.ticketOpenInfo.label,
                    playDateTimeYn: "Y",
                    playDateTime:
                        values.playDate.format("YYYY.MM.DD (ddd)") +
                        " " +
                        values.playTime,
                    siteLoginInfoYn: "Y",
                    siteLoginInfo:
                        values.loginId.trim() + " " + values.loginPwd.trim(),
                    hashedUserId: hashedUserId,
                },
            })
            .then((response) => {
                setState({ loading: false });

                // 서버가 정책상 거부한 경우 (예: 공연별 아이디수 마감)
                if (response.data?.messageYn === "Y") {
                    Modal.warning({
                        title: `알림`,
                        content: (
                            <>
                                <p style={{ whiteSpace: "pre-line" }}>
                                    <br />
                                    {response.data.messageStr}
                                </p>
                            </>
                        ),
                    });
                    return;
                }

                if (response.status === 200) {
                    Modal.success({
                        title: `성공적으로 신청되었습니다.`,
                        content: (
                            <>
                                <p>
                                    <br />
                                    {values.ticketOpenInfo.label}
                                    <br />
                                    <br />
                                    아이디 : {values.loginId.trim()}
                                    <br />
                                    비밀번호: {values.loginPwd.trim()}
                                    <br />
                                    <br />
                                    입력하신 비밀번호는
                                    <br />
                                    화면캡쳐해서 보관하세요.
                                </p>
                            </>
                        ),
                    });
                }
            })
            .catch((e) => {
                setState({ loading: false });
                console.error(e);
                Modal.error({
                    title: `알림`,
                    content: (
                        <>
                            <p>
                                <br />
                                오류가 발생하였습니다.
                                <br />
                                <br />
                                잠시후, 다시 시도해주세요.
                            </p>
                        </>
                    ),
                });
            });
    };

    const onFinishFailed = (errorInfo) => {
        console.log("Failed:", errorInfo);
    };

    const onFocus = (event) => {
        if (event.target.autocomplete) {
            event.target.autocomplete = "whatever";
        }
    };

    return (
        <div className="example">
            <Spin spinning={state.loading} size="large">
                <br />
                <PageHeader className="site-page-header" />
                <div className="form-container">
                    <Form
                        form={form}
                        name="basic"
                        size="large"
                        wrapperCol={{
                            span: 24,
                        }}
                        initialValues={{
                            remember: true,
                        }}
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        colon={false}
                    >
                        {/*
                        <Form.Item
                            name="ticketOpenInfo"
                            rules={[
                                {
                                    required: true,
                                    message: "[공연]을 선택하세요!",
                                },
                            ]}
                        >
                            <Select labelInValue placeholder="공연">
                                {orderListByKey(
                                    TicketOpens,
                                    "TicketOpenName"
                                ).map((open) => (
                                    <Option value={open.TicketOpenName}>
                                        {open.TicketOpenName}
                                    </Option>
                                ))}
                                <Option value="## 테스트">## 테스트</Option>
                            </Select>
                        </Form.Item>
		    */}
                        {/*
                        <Space
                            direction="vertical"
                            align="start"
                            size="2"
                            style={{
                                marginLeft: 40,
                                width: "100%",
                                justifyContent: "center",
                            }}
                        >
                            <Text style={{ color: "#0958d9" }}>
                                8월1일자 티켓팅부터,
                            </Text>
                            <Text style={{ color: "#0958d9" }}>
                                수고비 인상됩니다. (5만원→7만원)
                            </Text>
                            <br />
                        </Space>
		    */}
                        <Form.Item
                            name="ticketOpenInfo"
                            rules={[
                                {
                                    required: true,
                                    message: "[공연]을 선택하세요!",
                                },
                            ]}
                        >
                            <Select
                                labelInValue
                                onDropdownVisibleChange={(open) => {
                                    if (open) {
                                        fetch(setOpenData);
                                    }
                                }}
                                options={(openData || []).map((d) => ({
                                    value: d.value,
                                    label: d.text,
                                }))}
                                placeholder="공연"
                            ></Select>
                        </Form.Item>
                        <Form.Item
                            name="playDate"
                            rules={[
                                {
                                    required: true,
                                    message: "[공연 날짜]을 선택하세요!",
                                },
                            ]}
                        >
                            <DatePicker
                                format="YYYY.MM.DD (ddd)"
                                onChange={onChange}
                                allowClear={false}
                                suffixIcon={<DownOutlined />}
                                locale={locale}
                                placeholder="공연 날짜"
                            />
                        </Form.Item>
                        <Form.Item
                            name="playTime"
                            rules={[
                                {
                                    required: true,
                                    message: "[공연 시간]을 선택하세요!",
                                },
                            ]}
                        >
                            <AutoComplete
                                options={options}
                                placeholder="공연 시간"
                                filterOption={(inputValue, option) =>
                                    option.value
                                        .toUpperCase()
                                        .indexOf(inputValue.toUpperCase()) !==
                                    -1
                                }
                                maxLength={7}
                            />
                        </Form.Item>
                        <Form.Item
                            name="loginId"
                            dependencies={["ticketOpenInfo"]} // ticketOpenInfo를 감지
                            rules={[
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        const ticketOpenInfo =
                                            getFieldValue("ticketOpenInfo");

                                        if (!value) {
                                            return Promise.reject(
                                                new Error(
                                                    "[아이디]를 입력하세요!"
                                                )
                                            );
                                        }

                                        // 티켓링크([링]), 놀([놀])은 아이디를 이메일주소로만 받는다
                                        const label =
                                            ticketOpenInfo?.label || "";
                                        const isTicketLink =
                                            label.startsWith("[링]");
                                        const isNol = label.startsWith("[놀]");

                                        if (isTicketLink || isNol) {
                                            const emailIdRegex =
                                                /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/; // 이메일주소

                                            if (!emailIdRegex.test(value)) {
                                                return Promise.reject(
                                                    new Error(
                                                        (isTicketLink
                                                            ? "티켓링크는"
                                                            : "놀티켓은") +
                                                            " [이메일주소] 입력해주세요."
                                                    )
                                                );
                                            }
                                        }

                                        return Promise.resolve();
                                    },
                                }),
                            ]}
                        >
                            {/* 인터파크 아이디는 기존 가입 아이디라 메일 형식이 아닌데 @를 넣으라고 나옵니다 어떻게 해야 할까요?  */}
                            <Input
                                type="text"
                                // type="email"
                                // autocomplete="email"
                                placeholder="아이디"
                            />
                        </Form.Item>

                        <Form.Item
                            name="loginPwd"
                            dependencies={["ticketOpenInfo"]} // ticketOpenInfo를 감지
                            rules={[
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        const ticketOpenInfo =
                                            getFieldValue("ticketOpenInfo");

                                        if (!value) {
                                            return Promise.reject(
                                                new Error(
                                                    "[비밀번호]를 입력하세요!"
                                                )
                                            );
                                        }

                                        if (
                                            (
                                                ticketOpenInfo?.label || ""
                                            ).startsWith("[링]")
                                        ) {
                                            const tklGeneralPwdRegex =
                                                /^[0-9a-zA-Z!@#$%^*+=-~\-:./()<&; ]*$/; // 일반 비밀번호 형식
                                            if (
                                                !tklGeneralPwdRegex.test(value)
                                            ) {
                                                return Promise.reject(
                                                    new Error(
                                                        "올바른 [비밀번호]를 입력하세요!"
                                                    )
                                                );
                                            }

                                            const tklPwdRegex =
                                                /^[^\s]+ [0-9]{8}$/; // 문자열 + 빈칸 + 숫자 8자리
                                            if (!tklPwdRegex.test(value)) {
                                                return Promise.reject(
                                                    new Error(
                                                        "티켓링크는 [티켓링크비밀번호 생년월일8자리] 입력해주세요. 예> 'mypassQwe! 19870231'"
                                                    )
                                                );
                                            }
                                        } else {
                                            const generalPwdRegex =
                                                /^[0-9a-zA-Z!@#$%^*+=-~\-:./()<&;]*$/; // 일반 비밀번호 형식
                                            if (!generalPwdRegex.test(value)) {
                                                return Promise.reject(
                                                    new Error(
                                                        "올바른 [비밀번호]를 입력하세요!"
                                                    )
                                                );
                                            }
                                        }

                                        return Promise.resolve();
                                    },
                                }),
                            ]}
                        >
                            <Input.Password
                                placeholder="비번"
                                autoComplete="off"
                                onFocus={onFocus}
                                iconRender={(visible) =>
                                    visible ? (
                                        <EyeTwoTone />
                                    ) : (
                                        <EyeInvisibleOutlined />
                                    )
                                }
                                visibilityToggle={{
                                    visible: passwordVisible,
                                    onVisibleChange: setPasswordVisible,
                                }}
                            />
                        </Form.Item>

                        <Form.Item
                            name="userHp"
                            rules={[
                                {
                                    pattern: new RegExp(/^[0-9+-]*$/),
                                    message: "숫자만 입력가능합니다!",
                                },
                                {
                                    required: true,
                                    message: "[휴대폰번호]를 입력하세요!",
                                },
                            ]}
                        >
                            <Input
                                type="tel"
                                autocomplete="tel"
                                placeholder="연락가능 휴대폰번호"
                                maxLength={15}
                            />
                        </Form.Item>
                        <Form.Item {...tailLayout}>
                            <Space style={{ float: "right" }}>
                                <Button type="dashed" onClick={showModal}>
                                    티켓오픈일정
                                </Button>
                                <Modal
                                    className="ticket-open-modal"
                                    style={{
                                        top: 20,
                                    }}
                                    bodyStyle={{
                                        overflowY: "scroll",
                                        maxHeight: "calc(100vh - 200px)",
                                    }}
                                    title="티켓오픈일정"
                                    // title={
                                    //     <>
                                    //         <Button
                                    //             type="text"
                                    //             onClick={showModal}
                                    //         >
                                    //             티켓오픈일정
                                    //         </Button>
                                    //     </>
                                    // }
                                    visible={isModalOpen}
                                    footer={null}
                                    onCancel={handleCancel}
                                >
                                    <pre>{modalText}</pre>
                                    <div
                                        ref={setModalMoreEl}
                                        className={
                                            modalHasMore
                                                ? "ticket-open-more ticket-open-more-on"
                                                : "ticket-open-more"
                                        }
                                    >
                                        ▼
                                    </div>
                                </Modal>
                                <Button type="primary" htmlType="submit">
                                    신청하기
                                </Button>
                                <Button htmlType="button" onClick={onReset}>
                                    새로작성
                                </Button>
                            </Space>
                        </Form.Item>
                        {/*
                        <Space
                            direction="vertical"
                            align="end"
                            size="2"
                            style={{ width: "100%", justifyContent: "center" }}
                        >
                            <Title level={5}>
                                <a
                                    href="https://accounts.interpark.com/logout?retUrl=https%3A%2F%2Faccounts.interpark.com%2Fauthorize%2Fticket-pc%3FpostProc%3DFULLSCREEN%26origin%3Dhttps%253A%252F%252Fticket.interpark.com%252FGate%252FTPLoginConfirmGate.asp%253FGroupCode%253D%2526Tiki%253D%2526Point%253D%2526PlayDate%253D%2526PlaySeq%253D%2526HeartYN%253D%2526TikiAutoPop%253D%2526BookingBizCode%253D%2526MemBizCD%253DWEBBR%2526CPage%253D%2526GPage%253Dhttps%25253A%25252F%25252Ftickets.interpark.com%25252F%26version%3Dv2"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    인터파크 로그인 페이지
                                </a>
                            </Title>
                        </Space>
				    */}
                        {/*
                        <br />
                        <Collapse>
                            <Panel header="✨ 여러 회차 티켓팅 되나요?">
                                <p>
                                    아이디별로,
                                    <br />
                                    4개회차까지 신청가능합니다.
                                    <br />
                                    <br />
                                    but, 인터파크 예매시,
                                    <br />
                                    대기열(1아이디,1대기)이 적용되는 경우는,
                                    <br />
                                    <br />
                                    여러 회차를 티켓팅하는데,
                                    <br />
                                    어느 정도 제약이 있습니다.
                                    <br />
                                    <br />
                                    &lt;대기열이 없는 티켓팅인 경우는
                                    상관없습니다.&gt;
                                </p>
                            </Panel>
                            <Panel header="놀(인터파크) 로그인 관련">
                                <p>
                                    <Image
                                        width={300}
                                        src="https://xn--3r0b20nf5a.kr/logins.png"
                                    />
                                    <br />
                                    <br />
                                    현재는
                                    <br />
                                    <br />
                                    [인터파크계정 로그인],
                                    <br />
                                    [이메일 로그인]
                                    <br />
                                    <br />
                                    가능합니다. (불가:카카오,네이버,구글,애플)
                                </p>
                            </Panel>
                            <Panel header="할인권종 신청은 어떻게 하나요?">
                                <p>
                                    자세한 내용(좌석/매수/할인/연석)은 문자로
                                    알려주세요.
                                    <br />
                                    <br />
                                    실제로 작업할때, 문자메세지를 참고합니다.
                                </p>
                            </Panel>
                            <Panel header="티켓팅 당일 동시접속해도 되나요?">
                                <p>
                                    동접해도 괜찮습니다.
                                    <br />
                                    <br />
                                    다만 동일아이디로 타대리업체와 동시의뢰한
                                    경우,
                                    <br />
                                    인터파크제제(티켓취소,예매제한)가
                                    있을수있습니다.
                                </p>
                            </Panel>
                            <Panel header="두장 예매 가능할까요?">
                                <p>
                                    현실적으로 앞자리 연석은 쉽지 않으니,
                                    감안해주세요.
                                </p>
                            </Panel>
                            <Panel header="원하는 좌석 입력칸이 없어요.">
                                <p>
                                    자세한 내용(좌석/매수/할인/연석)은 문자로
                                    알려주세요.
                                    <br />
                                    <br />
                                    실제로 작업할때, 문자메세지를 참고합니다.
                                </p>
                            </Panel>
                            <Panel header="공연 목록에 원하는 공연이 없어요.">
                                <p>원하는 공연을 문자로 알려주세요.</p>
                            </Panel>
                        </Collapse>
                         */}
                    </Form>
                    {links.length > 0 && (
                        <>
                            {seatGroups(links).map((group, index) => (
                                <Fragment key={index}>
                                    <Divider />
                                    <Space
                                        direction="vertical"
                                        align="end"
                                        size="2"
                                        style={{
                                            width: "100%",
                                            justifyContent: "center",
                                        }}
                                    >
                                        {index === 0 && (
                                            <Title id="#Seat" level={5}></Title>
                                        )}

                                        <List
                                            dataSource={group}
                                            renderItem={renderSeatItem}
                                        />
                                        {/*
                                        <Title level={5}>-------------</Title>
			  */}
                                    </Space>
                                </Fragment>
                            ))}
                            <br />
                        </>
                    )}
                    {/*
                    <br />
                    <br />
                    <Space
                        direction="vertical"
                        align="end"
                        size="2"
                        style={{ width: "100%", justifyContent: "center" }}
                    >
                        <Title level={5}>루꼴라대리</Title>
                        <Title level={5}>
                            <a
                                href="https://twitter.com/TicketingRucola?ref_src=twsrc%5Etfw"
                                class="twitter-follow-button"
                                data-show-count="false"
                            >
                                @TicketingRucola
                            </a>
                            <script
                                async
                                src="https://platform.twitter.com/widgets.js"
                                charset="utf-8"
                            ></script>
                        </Title>
                        <Title level={5}>010-4881-3987</Title>
                    </Space>
                    <br />
                    <br />
                    <br />
                    <br />
		       */}
                </div>
            </Spin>
        </div>
    );
};

export default RequestNew;
